import '@fontsource-variable/inter';
import 'material-symbols/outlined.css';

import App from '@components/pages/public/book/App.vue';
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';

generateApplication(
  App,
  '#app',
  {
    injections: [
      { name: '$axios', module: generateAxiosInstance(hostApiKey, '/api/v1/book/') }
    ],
    props: {
      userSlug: bookingUserSlug || '',
      linkSlug: bookingLinkSlug || ''
    },
    packages: [],
    components: []
  }
);
